var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8Filtre2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 8.5 6 C 7.1364058 6 6 7.1364058 6 8.5 L 6 11.589844 C 6 13.886494 7.0554772 16.058837 8.859375 17.480469 L 19 25.470703 L 19 40.5 A 1.50015 1.50015 0 0 0 21.371094 41.720703 L 28.371094 36.720703 A 1.50015 1.50015 0 0 0 29 35.5 L 29 25.46875 L 39.140625 17.480469 C 40.944523 16.058837 42 13.886494 42 11.589844 L 42 8.5 C 42 7.1364058 40.863594 6 39.5 6 L 8.5 6 z M 9 9 L 39 9 L 39 11.589844 C 39 12.969193 38.369258 14.268678 37.285156 15.123047 L 27.287109 23 L 20.712891 23 L 10.714844 15.123047 C 9.6307412 14.268678 9 12.969193 9 11.589844 L 9 9 z M 22 26 L 26 26 L 26 34.728516 L 22 37.585938 L 22 26 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Filtre2);
export default __webpack_public_path__ + "static/media/icons8-filtre (2).9cec91f6d548c6273d276f3153cb351b.svg";
export { ForwardRef as ReactComponent };